import axios from 'App/axios';
import { StoreConfigurations, UpdateStoreResponse } from './dtos';

export const fetchStoreConfigurations = async () => {
  try {
    const { data } = await axios.get<StoreConfigurations>(
      `/admin/store/settings`,
    );

    return data;
  } catch (error) {
    throw new Error(
      `Failed to fetch Store Configuration: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`,
    );
  }
};

export const updateStoreConfigurations = async (
  params: StoreConfigurations,
): Promise<UpdateStoreResponse> => {
  try {
    const { data } = await axios.patch<UpdateStoreResponse>(
      `/admin/store/settings`,
      params,
    );

    return data;
  } catch (error) {
    throw new Error(
      `Failed to update Store Configuration: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`,
    );
  }
};

export default {
  fetchStoreConfigurations,
  updateStoreConfigurations,
};
